import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arr-r-lght",
  "use": "arr-r-lght-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"arr-r-lght\"><path d=\"M6.911 4.41a.833.833 0 0 1 1.179 0L13.679 10l-5.59 5.59a.833.833 0 0 1-1.178-1.18l4.41-4.41-4.41-4.41a.833.833 0 0 1 0-1.18Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol